import type { FirstAccountSetupState } from "@cmmd-forge/contracts";
import type { QueryClient } from "@tanstack/react-query";

import {
  CMMD_FORGE_ACCOUNT_PREFERENCES_QUERY_KEY,
  publishedCmmdSetupPreferences,
  updateCmmdForgeAccountPreferences,
} from "../../cmmd/forgeAccountPreferences";
import { toastManager } from "../ui/toast";

export function persistFirstAccountSetupProgress(input: {
  readonly queryClient: QueryClient;
  readonly state: FirstAccountSetupState;
  readonly updateLocalSettings: (state: FirstAccountSetupState) => void;
  readonly useCmmdSetupState: boolean;
}): void {
  if (!input.useCmmdSetupState) {
    input.updateLocalSettings(input.state);
    return;
  }
  input.queryClient.setQueryData(CMMD_FORGE_ACCOUNT_PREFERENCES_QUERY_KEY, {
    firstAccountSetup: input.state,
  });
  const preferences = publishedCmmdSetupPreferences(input.state);
  if (preferences === null) {
    return;
  }
  void updateCmmdForgeAccountPreferences({ queryClient: input.queryClient, preferences }).catch(
    (error: unknown) => {
      toastManager.add({
        type: "error",
        title: "Could not save setup progress",
        description: error instanceof Error ? error.message : "Try that setup step again.",
      });
      void input.queryClient.invalidateQueries({
        queryKey: CMMD_FORGE_ACCOUNT_PREFERENCES_QUERY_KEY,
      });
    },
  );
}
